export const SEARCH_TEXT = "Search";
